import Api from './axios';

const SocialApi = {
  session: () => Api.get('/auth/session/'),
  // the new session, or an error: 400 wrong email or password, 429 locked out after repeated failures
  // username is the user's email
  login: (username, password) => Api.post('/auth/login/', { username, password }),
  logout: () => Api.post('/auth/logout/'),
  // the session continues in another of the user's accounts (an id from session.accounts); the new session
  switchAccount: (account) => Api.post('/account/switch/', { account }),
  // checks connections and finds their ad accounts, in the background; the status is { syncing, failed }
  syncConnections: () => Api.post('/social/connections/sync/'),
  syncStatus: () => Api.get('/social/connections/sync/'),
  // configured sites (active SocialClientCredential rows), each with the user's connections
  sites: () => Api.get('/social/sites/'),
  // apps (SocialClientCredential rows), each with the user's connections made through it
  apps: () => Api.get('/social/apps/'),
  // the login URL of a site's app (credential id), or of its default app
  redirectUrl: (site, appId) => Api.get(`/social/redirect/${site}/`, { params: appId ? { client: appId } : {} }),
  connect: (site, data) => Api.post(`/social/connection/${site}/`, { data }),
};

export default SocialApi;
